import { useAuth0 } from "@auth0/auth0-react";
import config from "config/config";
import * as React from "react";

function authorizationHeaders(
  headers: HeadersInit | undefined,
  token: string
): Headers {
  const next = new Headers(headers);
  next.set("Authorization", `Bearer ${token}`);
  return next;
}

function useLlmFetch(): (path: string, init: RequestInit) => Promise<Response> {
  const { getAccessTokenSilently } = useAuth0();

  return React.useCallback(
    async (path: string, init: RequestInit): Promise<Response> => {
      const token = await getAccessTokenSilently();
      const baseUrl = (config.llmApiBaseUrl ?? "").replace(/\/+$/, "");
      return fetch(`${baseUrl}${path}`, {
        ...init,
        headers: authorizationHeaders(init.headers, token),
      });
    },
    [getAccessTokenSilently]
  );
}

export { useLlmFetch };
